import { render, staticRenderFns } from "./OrderPaymentsDetail.vue?vue&type=template&id=7bdb52bd&"
import script from "./OrderPaymentsDetail.vue?vue&type=script&lang=js&"
export * from "./OrderPaymentsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports